<template>
  <div class="row">
    <div class="col-20">
      <title-block
        :title="site.title"
      />
      <div class="row">
        <div class="col-20 std-wrapper p-4">
          <span
            v-if="site.content === 404"
            v-html="$t('view-Site.not-found')"
          />
          <span
            v-else
            v-html="site.content"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loader: false
    }
  },
  computed: {
    url () {
      return this.$route.params.url
    },
    site () {
      const site = this.$store.getters['sites/get'](this.url)

      if (site) {
        return site
      } else if (!this.loader) {
        return {
          title: '404',
          content: 404
        }
      } else {
        return {
          title: '',
          content: ''
        }
      }
    }
  },
  watch: {
    '$route.params.url': {
      handler (newValue) {
        this.loadSite()
      },
      immediate: true
    }
  },
  created () {
    this.loadSite()
  },
  methods: {
    loadSite () {
      this.loader = true
      this.$store.dispatch('sites/get', this.url).then((result) => {
        this.loader = false
      }).catch((e) => {
        this.loader = false
      })
    }
  }
}
</script>
